import type { IDoubleRowContainerProps } from './DoubleRowContainer'

import { styled } from '@linaria/react'

export const DoubleRowContainerStyled = styled.div<
  Pick<IDoubleRowContainerProps, 'paddings'>
>`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
`
